import { IconMark } from './Icons'

/** The two-weight wordmark used everywhere the brand name appears. */
export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`wordmark ${className}`}>
      <b>ItsBing</b><span>MyBusiness</span>
    </span>
  )
}

const POINTS = [
  'DKIM, SPF and DMARC set up for you',
  'REST API, SMTP relay and email campaigns',
  'One-click unsubscribe and automatic suppression',
  'Every sender identity-verified — a cleaner shared reputation',
]

// Purely illustrative UI: shows what the delivery log looks like, not real traffic.
const LOG = [
  { to: 'gmail.com', status: 'Delivered', detail: '250 2.0.0 OK' },
  { to: 'outlook.com', status: 'Delivered', detail: '250 2.6.0 Queued' },
  { to: 'yahoo.com', status: 'Delivered', detail: '250 ok' },
]

/** Branded panel on the left of every sign-in / sign-up / verify / reset screen (desktop only). */
export function AuthAside() {
  return (
    <aside className="auth-aside" aria-hidden="true">
      <div className="auth-aside-top">
        <span className="auth-aside-mark"><IconMark /></span>
        <Wordmark />
      </div>

      <div className="auth-aside-body">
        <p className="auth-aside-eyebrow"><i /> Email infrastructure for growing teams</p>
        <h2>Email that lands<br /><em>in the inbox.</em></h2>
        <p className="auth-aside-lead">
          Transactional and marketing email from your own domain — signed, tracked and compliant
          in the US, UK and Europe.
        </p>
        <ul>
          {POINTS.map(p => (
            <li key={p}>
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none"><circle cx="12" cy="12" r="10" fill="#1de9b6" /><path d="m7.5 12.2 3 3 6-6.4" stroke="#0a0a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
              {p}
            </li>
          ))}
        </ul>

        <div className="auth-aside-log">
          <div className="auth-aside-log-head"><span><i /> Delivery log</span><span>DKIM · SPF · DMARC pass</span></div>
          {LOG.map(r => (
            <div className="auth-aside-log-row" key={r.to}>
              <span className="mono">{r.to}</span>
              <span className="auth-aside-pill">{r.status}</span>
              <span className="mono muted">{r.detail}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="auth-aside-foot">
        Free plan · up to 250 emails a day after verification · no card required
      </div>
    </aside>
  )
}
